import { useMutation } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useProfile } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError } from 'utils/types';

import { LOGIN_FORM } from '../forms/schema';

export default function useAdminLogin() {
  const { state } = useProvider();
  const { setProfile } = useProfile();
  const args = state;

  return useMutation<any, ApiError, LOGIN_FORM, any>({
    mutationFn: async (payload) => {
      const api = new Api(args);

      const data = await api.post({
        url: 'api/v1/auth/admins/login',
        payload,
      });

      return data;
    },
    onMutate: (variables) => {
      const { remember } = variables;

      return remember;
    },
    onSuccess: (successData, { remember }) => {
      setProfile({ profile: successData.data, remember });

      window.location.href = '/';
    },
  });
}
